export default __webpack_public_path__ + "static/media/neuron.e40133ed.png";